export default "__VITE_ASSET__CbCznqw5__"